/**
 * @param {*} value
 * @returns {number}
 */
export default function toNumber(value) {
    return parseFloat(value) || 0;
}
